webpackJsonp([179642632655092],{

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Philosophy = __webpack_require__(65);
	
	var _Philosophy2 = _interopRequireDefault(_Philosophy);
	
	var _TocLink = __webpack_require__(61);
	
	var _TocLink2 = _interopRequireDefault(_TocLink);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Philosophy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Non-Redux Developers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lastly, for developers who don\'t want to use Redux, Lore has very little ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'direct value'
	      ),
	      '. Redux is a central component of the framework, and there\'s no getting away from it. Replacing it would require rewriting just about everything.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But the framework might provide some ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'indirect value'
	      ),
	      ' in it\'s effort to capture common application concerns that a framework (or architecture) ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'should'
	      ),
	      ' solve for, as well as small examples that demonstrate and test each of those concerns.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'So if you\'re looking to build your own framework, or evaluating a non-Redux solution, it might be worthwhile to browse through the examples and use cases Lore is solving as a way of comparing solutions or thinking through common application concerns, or reading through the Quickstart since it covers the majority of common use cases that Lore was created to solve.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-philosophy-audience-non-redux-js-b28cd84d2a7c7ea47297.js